import { throttle } from './timing';

const RESIZE_THROTTLE_LIMIT = 50;

class WindowResizeObserver {
    constructor() {
        this._observers = new Set();
        this._resizeHandler = null;
        this._lastWidth = document.documentElement.clientWidth;
    }

    observe(callback) {
        this._observers.add(callback);

        if (this._observers.size === 1) {
            this._start();
        }

        callback(this._lastWidth);
    }

    unobserve(callback) {
        this._observers.delete(callback);

        if (this._observers.size === 0) {
            this._stop();
        }
    }

    _start() {
        if (this._resizeHandler) {
            console.warn('WindowObserver already started');
            return;
        }

        this._resizeHandler = throttle(() => {
            this._lastWidth = document.documentElement.clientWidth;
            const lastWidth = this._lastWidth; // avoid race conditions

            this._observers.forEach(callback => callback(lastWidth));
        }, RESIZE_THROTTLE_LIMIT, true);
        window.addEventListener('resize', this._resizeHandler);
    }

    _stop() {
        if (!this._resizeHandler) {
            return;
        }

        window.removeEventListener('resize', this._resizeHandler);
        this._resizeHandler = null;
    }
}

export default new WindowResizeObserver();
